import { toFormData } from "@/app/shared/utils/helpers";
import httpManager from "@/app/shared/utils/httpManager";

export async function importClientProductsTemplate(payload) {
  const response = await httpManager.upload("/imports/clients-accounts/", toFormData(payload));
  return response?.data;
}
